<template>
  <div ref="galleryGridWrapp">
    <!-- Error message -->
    <div
      class="container flex justify-center text-red text-center"
      v-if="errorStatus"
      fade
      fade-trigger="scroll"
    >
      <h2 class="title h3">{{ errorMessage }}</h2>
    </div>

    <!-- Gallery Grid -->
    <div
      class="grid grid-cols-1 md:grid-cols-2 md:pb-10 border-t border-[#EDEDED]"
    >
      <gallery-item
        v-for="(image, index) in images"
        :key="index"
        :src="image.src"
        :alt="image.alt"
        :index="index"
      ></gallery-item>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import galleryItem from './gallery-item.vue'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export default {
  components: {
    galleryItem,
  },

  props: {
    imagesUrl: {
      type: String,
      required: true,
    },
    errorMessage: {
      type: String,
      required: true,
    },
    loadingText: {
      type: String,
      required: true,
      default: 'Loading...',
    },
  },

  data() {
    return {
      images: [],
      errorStatus: true,
      loading: true,
    }
  },

  methods: {
    scrollToTop() {
      const container = this.$refs.galleryGridWrapp
      window.smoother.scrollTo(container, true, 'top 100px')
    },
  },

  mounted() {
    axios
      .get(this.imagesUrl)
      .then(response => {
        this.errorStatus = false

        this.images = response.data

        this.loading = false
      })
      .then(() => {
        this.errorStatus = false
        ScrollTrigger.refresh()
        this.scrollToTop()
      })
      .catch(() => {
        this.errorStatus = true
      })
  },
}
</script>
